import { SupportTab } from '../../common/keys';
import { TABS } from './support-constants';

/** Primary view template(s) each tab needs before first paint. */
export const TAB_PRIMARY_VIEWS = Object.freeze({
  [TABS.HOME]: ['support-home'],
  [TABS.OPEN_TICKET]: ['support-open-ticket'],
  [TABS.MY_CASES]: ['support-my-cases'],
  [TABS.REDEEM_CODE]: ['support-redeem-code'],
  [TABS.OFFLINE_FORM]: ['offline-form'],
  [TABS.ADMIN_FORM]: ['admin-form'],
});

const ORG_PICKER_VIEWS = ['support-orglist-item'];

export function tabUsesOrgPicker(tab) {
  return tab !== TABS.REDEEM_CODE;
}

/** Left-nav setup (role checks, chat, entitlements) — not needed when sidebar is hidden. */
export function tabUsesSidebarSetup(tab) {
  return tab !== TABS.REDEEM_CODE;
}

/** Commerce / Workfront / ECC discovery before first paint. */
export function tabNeedsOrgAccessBeforePaint(tab) {
  return tabUsesOrgPicker(tab);
}

/** Experience League profile API (orgs, interactions) vs IMS display fields only. */
export function tabNeedsExperienceLeagueProfile(tab) {
  return tab !== TABS.REDEEM_CODE;
}

export function resolveSupportTab(supportTabs) {
  const url = new URL(window.location.href);
  const fromQuery = url.searchParams.get('support-tab');
  const fromSession = sessionStorage.getItem(SupportTab);
  const fromHash = window.location.hash.replace(/^#/, '').split('/')[0];

  for (const candidate of [fromQuery, fromSession, fromHash]) {
    if (candidate && supportTabs.includes(candidate)) {
      return candidate;
    }
  }

  return TABS.HOME;
}

export function getInitialSupportTab(supportTabs) {
  return resolveSupportTab(supportTabs);
}

export function isLoggedOutRedeemTab(tab, authenticated) {
  return !authenticated && tab === TABS.REDEEM_CODE;
}

/** True when URL/session/hash indicates redeem (even if routed tab arg differs). */
export function isLoggedOutRedeemIntent(supportTabs, authenticated) {
  return !authenticated && resolveSupportTab(supportTabs) === TABS.REDEEM_CODE;
}

/**
 * View templates to await before rendering a tab.
 * @param {string} tab
 * @param {{ authenticated?: boolean }} [options]
 */
export function getViewsRequiredForTab(tab, { authenticated = true } = {}) {
  if (tab === TABS.REDEEM_CODE && !authenticated) {
    return [];
  }

  const primary = [...(TAB_PRIMARY_VIEWS[tab] ?? TAB_PRIMARY_VIEWS[TABS.HOME])];
  if (tab === TABS.MY_CASES && new URL(window.location.href).searchParams.has('case-id')) {
    primary.push('support-case-detail');
  }
  const shell = authenticated && tabUsesOrgPicker(tab) ? ORG_PICKER_VIEWS : [];

  return [...new Set([...primary, ...shell])];
}
